export const LOGIN_USER_PASS_REQUEST = '[User] LOGIN_USER_PASS_REQUEST'
export const LOGIN_USER_PASS_SUCCESS = '[User] LOGIN_USER_PASS_SUCCESS'
export const LOGIN_USER_PASS_FAILURE = '[User] LOGIN_USER_PASS_FAILURE'
